import Dummy from '../../utils/dummy';
import Main from '../../types/enums/main';
import moreContentRequest from './moreContentRequest';
import { Observable } from 'rxjs';

const WAITING_TIME = 100;

export function contentObservable() {
  return new Observable((subscriber) => {
    subscriber.next(Dummy.getPhoto());
    moreContentRequest().then((data) => {
      setTimeout(() => {
        subscriber.next({ data, type: Main.RAILS });
        subscriber.complete();
      }, WAITING_TIME);
    });
  });
}

export default contentObservable;
